

const firebaseConfig = {
    apiKey: "AIzaSyDu1ds1zCTqfUX5SPoq1qIShGSCh-DORTQ",
    authDomain: "tcsdatabank.firebaseapp.com",
    databaseURL: "https://tcsdatabank-default-rtdb.firebaseio.com",
    projectId: "tcsdatabank",
    storageBucket: "tcsdatabank.firebasestorage.app",
    messagingSenderId: "815139903075",
    appId: "1:815139903075:web:3f652a0756c9c32c6d8a56"
};
export default firebaseConfig;
